import { useCallback } from 'react';
import { useDependency } from '../contexts/DependencyProvider';
import {
  getActivityCustomFormDefaultValues,
  persistCustomFormValues,
  FormInitializationServices,
} from '../utils/activityFormInitialization';

export function useActivityFormInitialization() {
  const { store, featureService, formService } = useDependency();

  const getDefaultValues = useCallback(
    async (
      activityType: number,
      contextTypeFormId?: string | null,
      templateFormId?: string | null
    ): Promise<Record<string, any>> => {
      const services: FormInitializationServices = {
        featureService,
        formService,
        store,
      };
      return getActivityCustomFormDefaultValues(
        activityType,
        contextTypeFormId ?? undefined,
        templateFormId ?? undefined,
        services
      );
    },
    [store, featureService, formService]
  );

  const persistFormValues = useCallback(
    async (
      formValuesId: number,
      values: Record<string, any>
    ): Promise<boolean> => {
      const services: FormInitializationServices = {
        featureService,
        formService,
        store,
      };
      return persistCustomFormValues(formValuesId, values, services);
    },
    [store, formService]
  );

  return { getDefaultValues, persistFormValues };
}
